
import React from 'react';
import { VolunteeringSection } from '../home/components/VolunteeringSection';

const GetInvolvedPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-600 to-orange-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Get Involved</h1>
            <p className="text-xl md:text-2xl text-red-100 max-w-3xl mx-auto">
              Join our vibrant community and help preserve Persian culture for future generations
            </p>
          </div>
        </div>
      </section>

      {/* Ways to Get Involved */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Ways to Make a Difference</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              There are many ways to support our mission and connect with the Persian community
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-red-50 rounded-xl">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Volunteer</h3>
              <p className="text-gray-600 mb-4">
                Help with events, teaching, administration, and community outreach programs
              </p>
              <a href="#volunteer" className="text-red-600 font-medium hover:text-red-700 cursor-pointer">
                Learn More →
              </a>
            </div>

            <div className="text-center p-6 bg-orange-50 rounded-xl">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-gift-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Donate</h3>
              <p className="text-gray-600 mb-4">
                Support our programs, events, and facility maintenance with financial contributions
              </p>
              <a href="/donate" className="text-orange-600 font-medium hover:text-orange-700 cursor-pointer">
                Donate Now →
              </a>
            </div>

            <div className="text-center p-6 bg-yellow-50 rounded-xl">
              <div className="w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-event-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Attend Events</h3>
              <p className="text-gray-600 mb-4">
                Participate in our cultural events, workshops, and community gatherings
              </p>
              <a href="/events" className="text-yellow-600 font-medium hover:text-yellow-700 cursor-pointer">
                View Events →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Membership Benefits */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Membership Benefits</h2>
            <p className="text-lg text-gray-600">
              Become a member and enjoy exclusive benefits while supporting our community
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <i className="ri-discount-percent-line text-red-600 text-2xl mb-3"></i>
              <h3 className="font-semibold text-gray-900 mb-2">Event Discounts</h3>
              <p className="text-gray-600 text-sm">Special pricing on all cultural events and workshops</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <i className="ri-mail-line text-red-600 text-2xl mb-3"></i>
              <h3 className="font-semibold text-gray-900 mb-2">Newsletter</h3>
              <p className="text-gray-600 text-sm">Monthly updates on community news and upcoming events</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <i className="ri-group-line text-red-600 text-2xl mb-3"></i>
              <h3 className="font-semibold text-gray-900 mb-2">Community Access</h3>
              <p className="text-gray-600 text-sm">Connect with other members through exclusive gatherings</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <i className="ri-vote-line text-red-600 text-2xl mb-3"></i>
              <h3 className="font-semibold text-gray-900 mb-2">Voting Rights</h3>
              <p className="text-gray-600 text-sm">Participate in board elections and important decisions</p>
            </div>
          </div>
        </div>
      </section>

      {/* Volunteering Section */}
      <div id="volunteer">
        <VolunteeringSection />
      </div>

      {/* Contact CTA */}
      <section className="py-16 bg-red-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-xl text-red-100 mb-8">
            Have questions about getting involved? We'd love to hear from you!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/about/contact"
              className="bg-white text-red-600 px-8 py-3 rounded-lg font-medium hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </a>
            <a
              href="mailto:info@kanoonatlanta.org"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-medium hover:bg-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Send Email
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GetInvolvedPage;